<template>
  <div :class="`home_templates ${className}`" :style="{background}">
    <a-spin :spinning="loading">
      <div class="title"><span>{{title}}</span><i v-if="icon" @click="submit(true)" class="iconfont icon-wjjf_icon_line_help" /></div>
      <div v-if="titleEn" class="title_en">{{titleEn}}</div>
      <div v-if="subheading" class="subheading">{{subheading}}</div>
      <slot />
      <a-button v-if="moreEvent" @click.native="moreEvent">{{ t('home.viewMore') }}</a-button>
    </a-spin>
  </div>
</template>

<script>
import { t } from '@/locales';
export default {
  props: {
    title: { type: String, default: null },
    titleEn: { type: String, default: null },
    subheading: { type: String, default: null },
    icon: { type: Boolean, default: false },
    loading: { type: Boolean, default: true },
    background: { type: String, default: "#EEEEEE" },
    className: { type: String, default: null },
    moreEvent: { type: Function | Boolean, default: () => null },
    submit: { type: Function, default: () => null }
  },
  methods: { t }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>